module.exports = __webpack_public_path__ + "static/media/Follower_Button-13.d2c4db00.png";